import colors from './variables/colors';
import metrics from './variables/metrics';
import typography from './variables/typography';

const theme = {
  colors,
  metrics,
  typography,
};

export default theme;
